import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from 'react-oidc-context';
import { HEADER_BACKGROUND, CognitoDomain, UserPoolClientId } from '../utilities/constants';

export default function Header() {
  const auth = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  const handleLogout = () => {
    setUserMenuAnchor(null);
    auth.removeUser();
    const postLogoutUri = encodeURIComponent(`${window.location.origin}/`);
    window.location.href = `${CognitoDomain}/logout?client_id=${UserPoolClientId}&logout_uri=${postLogoutUri}`;
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ backgroundColor: HEADER_BACKGROUND, borderBottom: '1px solid rgba(255,255,255,0.08)', zIndex: (t) => t.zIndex.drawer + 1 }}
      role="banner"
      aria-label="Application Header"
    >
      <Toolbar sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: { xs: 56, sm: 64 },
        backgroundColor: HEADER_BACKGROUND,
      }}>

        {/* Left: Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
          <img
            src="/scale.png"
            alt="ScaleCapacity logo"
            style={{
              height: isMobile ? '28px' : '36px',
              width: 'auto',
              padding: '6px 10px',
            }}
          />
        </Box>

        {/* Right: User icon with logout dropdown */}
        <Box sx={{ display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
          <IconButton
            onClick={(e) => setUserMenuAnchor(e.currentTarget)}
            sx={{
              color: '#E8E8FF',
              padding: '8px',
              '&:hover': { backgroundColor: 'rgba(232,232,255,0.1)' },
            }}
            aria-label="User menu"
          >
            <AccountCircleIcon sx={{ fontSize: '32px' }} />
          </IconButton>

          <Menu
            anchorEl={userMenuAnchor}
            open={Boolean(userMenuAnchor)}
            onClose={() => setUserMenuAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                mt: 1.5,
                minWidth: 180,
                boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
              },
            }}
          >
            <MenuItem
              onClick={handleLogout}
              sx={{ '&:hover': { backgroundColor: 'rgba(95,91,205,0.1)' } }}
            >
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Log out</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
